"use strict";

var _regeneratorRuntime = require("/workspace/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/workspace/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _createClass = require("/workspace/node_modules/@babel/runtime/helpers/createClass");

var _get = require("/workspace/node_modules/@babel/runtime/helpers/get");

var _inherits = require("/workspace/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/workspace/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/workspace/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _classCallCheck = require("/workspace/node_modules/@babel/runtime/helpers/classCallCheck");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var events_1 = require("events");

var logger_1 = require("./logger");

var configuration_1 = require("./configuration");

var twilsock_1 = require("./twilsock");

var packetinterface_1 = require("./packetinterface");

var websocketchannel_1 = require("./websocketchannel");

var registrations_1 = require("./services/registrations");

var upstream_1 = require("./services/upstream");

var deferred_1 = require("./deferred");

var twilsockerror_1 = require("./error/twilsockerror");

var offlinestorage_1 = require("./offlinestorage");

var tokenStorage_1 = require("./tokenStorage");

var telemetrytracker_1 = require("./services/telemetrytracker");

var TelemetryEvents = function TelemetryEvents() {
  _classCallCheck(this, TelemetryEvents);
};

exports.TelemetryEvents = TelemetryEvents;
TelemetryEvents.TWILSOCK_CONNECT = 'twilsock.sdk.connect'; // establish WebSocket connection (with WebSocket handshake finished)

TelemetryEvents.TWILSOCK_INIT = 'twilsock.sdk.init'; // send "init" message and receive reply

/**
 * @alias Twilsock
 * @classdesc Client library for the Twilsock service
 * It allows to recevie service-generated updates as well as bi-directional transport
 * @fires Twilsock#message
 * @fires Twilsock#connected
 * @fires Twilsock#disconnected
 * @fires Twilsock#tokenAboutToExpire
 * @fires Twilsock#stateChanged
 * @fires Twilsock#connectionError
 */

var TwilsockClient = /*#__PURE__*/function (_events_1$EventEmitte) {
  _inherits(TwilsockClient, _events_1$EventEmitte);

  var _super = _createSuper(TwilsockClient);

  /**
   * @param {string} token Twilio access token
   * @param {string} productId Product identifier. Should be the same as a grant name in token
   */
  function TwilsockClient(token, productId) {
    var _this;

    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    _classCallCheck(this, TwilsockClient);

    _this = _super.call(this);
    _this.offlineStorageDeferred = new deferred_1.Deferred();
    options.continuationToken = options.continuationToken ? options.continuationToken : tokenStorage_1.TokenStorage.getStoredToken(productId);
    var config = _this.config = new configuration_1.Configuration(token, productId, options);
    logger_1.log.setLevel(config.logLevel);
    var websocket = new websocketchannel_1.WebSocketChannel(config.url);
    var transport = options.transport ? options.transport : new packetinterface_1.PacketInterface(websocket, config);
    _this.channel = options.channel ? options.channel : new twilsock_1.TwilsockImpl(websocket, transport, config);
    _this.registrations = options.registrations ? options.registrations : new registrations_1.Registrations(transport);
    _this.upstream = new upstream_1.Upstream(transport, _this.channel, config); // Send telemetry only when connected and initialised

    _this.telemetryTracker = new telemetrytracker_1.TelemetryTracker(config, transport);

    _this.channel.on('initialized', function () {
      return _this.telemetryTracker.canSendTelemetry = true;
    });

    websocket.on('disconnected', function () {
      return _this.telemetryTracker.canSendTelemetry = false;
    });

    _this.registrations.on('registered', function (id) {
      return _this.emit('registered', id);
    });

    _this.channel.on('message', function (type, message) {
      return setTimeout(function () {
        return _this.emit('message', type, message);
      }, 0);
    });

    _this.channel.on('stateChanged', function (state) {
      return setTimeout(function () {
        return _this.emit('stateChanged', state);
      }, 0);
    });

    _this.channel.on('connectionError', function (connectionError) {
      return setTimeout(function () {
        return _this.emit('connectionError', connectionError);
      }, 0);
    });

    _this.channel.on('tokenAboutToExpire', function () {
      return setTimeout(function () {
        return _this.emit('tokenAboutToExpire');
      }, 0);
    });

    _this.channel.on('tokenExpired', function () {
      return setTimeout(function () {
        return _this.emit('tokenExpired');
      }, 0);
    });

    _this.channel.on('connected', function () {
      return _this.registrations.updateRegistrations();
    });

    _this.channel.on('connected', function () {
      return _this.upstream.sendPendingMessages();
    });

    _this.channel.on('connected', function () {
      return setTimeout(function () {
        return _this.emit('connected');
      }, 0);
    }); // Twilsock telemetry events


    _this.channel.on('beforeConnect', function () {
      return _this.telemetryTracker.addPartialEvent(new telemetrytracker_1.TelemetryEventDescription('Establish WebSocket connection', '', new Date()), TelemetryEvents.TWILSOCK_CONNECT, telemetrytracker_1.TelemetryPoint.Start);
    });

    _this.channel.on('connected', function () {
      return _this.telemetryTracker.addPartialEvent(new telemetrytracker_1.TelemetryEventDescription('Establish WebSocket connection', '', new Date(), new Date()), TelemetryEvents.TWILSOCK_CONNECT, telemetrytracker_1.TelemetryPoint.End);
    });

    _this.channel.on('beforeSendInit', function () {
      return _this.telemetryTracker.addPartialEvent(new telemetrytracker_1.TelemetryEventDescription('Send Twilsock init', '', new Date()), TelemetryEvents.TWILSOCK_INIT, telemetrytracker_1.TelemetryPoint.Start);
    });

    _this.channel.on('initialized', function () {
      return _this.telemetryTracker.addPartialEvent(new telemetrytracker_1.TelemetryEventDescription('Send Twilsock init', 'Succeeded', new Date(), new Date()), TelemetryEvents.TWILSOCK_INIT, telemetrytracker_1.TelemetryPoint.End);
    });

    _this.channel.on('sendInitFailed', function () {
      return _this.telemetryTracker.addPartialEvent(new telemetrytracker_1.TelemetryEventDescription('Send Twilsock init', 'Failed', new Date(), new Date()), TelemetryEvents.TWILSOCK_INIT, telemetrytracker_1.TelemetryPoint.End);
    });

    _this.channel.on('initialized', function (initReply) {
      _this.handleStorageId(productId, initReply);

      tokenStorage_1.TokenStorage.storeToken(initReply.continuationToken, productId);
      setTimeout(function () {
        return _this.emit('initialized', initReply);
      }, 0);
    });

    _this.channel.on('disconnected', function () {
      return setTimeout(function () {
        return _this.emit('disconnected');
      }, 0);
    });

    _this.channel.on('disconnected', function () {
      return _this.upstream.rejectPendingMessages();
    });

    _this.channel.on('disconnected', function () {
      return _this.offlineStorageDeferred.fail(new twilsockerror_1.TwilsockError('Client disconnected'));
    });

    _this.offlineStorageDeferred.promise.catch(function () {});

    return _this;
  }

  _createClass(TwilsockClient, [{
    key: "emit",
    value: function emit(event) {
      var _get2;

      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      logger_1.log.debug("Emitting ".concat(event.toString(), "(").concat(args.map(function (a) {
        return JSON.stringify(a);
      }).join(', '), ")"));
      return (_get2 = _get(_getPrototypeOf(TwilsockClient.prototype), "emit", this)).call.apply(_get2, [this, event].concat(args));
    }
  }, {
    key: "handleStorageId",
    value: function handleStorageId(productId, initReply) {
      if (!initReply.offlineStorage) {
        this.offlineStorageDeferred.fail(new twilsockerror_1.TwilsockError('No offline storage id'));
      } else if (initReply.offlineStorage.hasOwnProperty(productId)) {
        try {
          this.offlineStorageDeferred.set(offlinestorage_1.OfflineProductStorage.create(initReply.offlineStorage[productId]));
          logger_1.log.debug("Offline storage for '".concat(productId, "' product: ").concat(JSON.stringify(initReply.offlineStorage[productId]), "."));
        } catch (e) {
          this.offlineStorageDeferred.fail(new twilsockerror_1.TwilsockError("Failed to parse offline storage for ".concat(productId, " ").concat(JSON.stringify(initReply.offlineStorage[productId]), ". ").concat(e, ".")));
        }
      } else {
        this.offlineStorageDeferred.fail(new twilsockerror_1.TwilsockError("No offline storage id for '".concat(productId, "' product: ").concat(JSON.stringify(initReply.offlineStorage))));
      }
    }
    /**
     * Get offline storage ID
     * @returns {Promise}
     */

  }, {
    key: "storageId",
    value: function storageId() {
      return this.offlineStorageDeferred.promise;
    }
    /**
     * Indicates if twilsock is connected now
     * @returns {Boolean}
     */

  }, {
    key: "isConnected",
    get: function get() {
      return this.channel.isConnected;
    }
    /**
     * Current state
     * @returns {String}
     */

  }, {
    key: "state",
    get: function get() {
      return this.channel.state;
    }
    /**
     * Update token
     * @param {String} token
     * @returns {Promise}
     */

  }, {
    key: "updateToken",
    value: function () {
      var _updateToken = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(token) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                logger_1.log.trace("updating token '".concat(token, "'"));

                if (!(this.config.token === token)) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return");

              case 3:
                this.config.updateToken(token);
                return _context.abrupt("return", this.channel.updateToken(token));

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function updateToken(_x) {
        return _updateToken.apply(this, arguments);
      }

      return updateToken;
    }()
    /**
     * Updates notification context.
     * This method shouldn't be used anyone except twilio notifications library
     * @param contextId id of notification context
     * @param context value of notification context
     * @private
     */

  }, {
    key: "setNotificationsContext",
    value: function setNotificationsContext(contextId, context) {
      this.registrations.setNotificationsContext(contextId, context);
    }
    /**
     * Remove notification context.
     * This method shouldn't be used anyone except twilio notifications library
     * @param contextId id of notification context
     * @private
     */

  }, {
    key: "removeNotificationsContext",
    value: function removeNotificationsContext(contextId) {
      this.registrations.removeNotificationsContext(contextId);
    }
    /**
     * Connect to the server
     * @fires Twilsock#connected
     * @public
     * @returns {void}
     */

  }, {
    key: "connect",
    value: function connect() {
      return this.channel.connect();
    }
    /**
     * Disconnect from the server
     * @fires Twilsock#disconnected
     * @public
     * @returns {Promise}
     */

  }, {
    key: "disconnect",
    value: function disconnect() {
      this.telemetryTracker.sendTelemetry(telemetrytracker_1.EventSendingLimitation.AnyEventsIncludingUnfinished);
      return this.channel.disconnect();
    }
    /**
     * Get HTTP request to upstream service
     * @param {string} url Upstream service url
     * @param {headers} headers Set of custom headers
     * @param {string} [grant] The product grant
     * @returns {Promise}
     */

  }, {
    key: "get",
    value: function get(url, headers, grant) {
      this.telemetryTracker.sendTelemetry(telemetrytracker_1.EventSendingLimitation.AnyEvents); // send collected telemetry (if any) before upstream message shipment

      return this.upstream.send('GET', url, headers, undefined, grant);
    }
    /**
     * Post HTTP request to upstream service
     * @param {string} url Upstream service url
     * @param {headers} headers Set of custom headers
     * @param {body} body Body to send
     * @param {string} [grant] The product grant
     * @returns {Promise}
     */

  }, {
    key: "post",
    value: function post(url, headers, body, grant) {
      this.telemetryTracker.sendTelemetry(telemetrytracker_1.EventSendingLimitation.AnyEvents); // send collected telemetry (if any) before upstream message shipment

      return this.upstream.send('POST', url, headers, body, grant);
    }
    /**
     * Put HTTP request to upstream service
     * @param {string} url Upstream service url
     * @param {headers} headers Set of custom headers
     * @param {body} body Body to send
     * @param {string} [grant] The product grant
     * @returns {Promise}
     */

  }, {
    key: "put",
    value: function put(url, headers, body, grant) {
      this.telemetryTracker.sendTelemetry(telemetrytracker_1.EventSendingLimitation.AnyEvents); // send collected telemetry (if any) before upstream message shipment

      return this.upstream.send('PUT', url, headers, body, grant);
    }
    /**
     * Delete HTTP request to upstream service
     * @param {string} url Upstream service url
     * @param {headers} headers Set of custom headers
     * @param {string} [grant] The product grant
     * @returns {Promise}
     */

  }, {
    key: "delete",
    value: function _delete(url, headers, grant) {
      this.telemetryTracker.sendTelemetry(telemetrytracker_1.EventSendingLimitation.AnyEvents); // send collected telemetry (if any) before upstream message shipment

      return this.upstream.send('DELETE', url, headers, undefined, grant);
    }
    /**
     * Submits internal telemetry event. Not to be used for any customer and/or sensitive data.
     * @param {TelemetryEventDescription} event Event details.
     * @returns {void}
     */

  }, {
    key: "addTelemetryEvent",
    value: function addTelemetryEvent(event) {
      this.telemetryTracker.addTelemetryEvent(event);
      this.telemetryTracker.sendTelemetryIfMinimalPortionCollected(); // send telemetry if need
    }
    /**
     * Submits internal telemetry event. Not to be used for any customer and/or sensitive data.
     * @param {TelemetryEventDescription} event Event details.
     * @param {string} eventKey Unique event key.
     * @param {TelemetryPoint} point Is this partial event for start or end of measurement.
     * @returns {void}
     */

  }, {
    key: "addPartialTelemetryEvent",
    value: function addPartialTelemetryEvent(event, eventKey, point) {
      this.telemetryTracker.addPartialEvent(event, eventKey, point);

      if (point === telemetrytracker_1.TelemetryPoint.End) {
        // this telemetry event is complete, so minimal portion could become ready to send
        this.telemetryTracker.sendTelemetryIfMinimalPortionCollected(); // send telemetry if need
      }
    }
  }]);

  return TwilsockClient;
}(events_1.EventEmitter);

exports.TwilsockClient = TwilsockClient;
exports.Twilsock = TwilsockClient;
/**
 * Twilsock destination address descriptor
 * @typedef {Object} Twilsock#Address
 * @property {String} method - HTTP method. (POST, PUT, etc)
 * @property {String} host - host name without path. (e.g. my.company.com)
 * @property {String} path - path on the host (e.g. /my/app/to/call.php)
 */

/**
 * Twilsock upstream message
 * @typedef {Object} Twilsock#Message
 * @property {Twilsock#Address} to - destination address
 * @property {Object} headers - HTTP headers
 * @property {Object} body - Body
 */

/**
 * Fired when new message received
 * @param {Twilsock#Message} message
 * @event Twilsock#message
 */

/**
 * Fired when socket connected
 * @param {String} URI of endpoint
 * @event Twilsock#connected
 */

/**
 * Fired when socket disconnected
 * @event Twilsock#disconnected
 */

/**
 * Fired when token is about to expire and should be updated
 * @event Twilsock#tokenAboutToExpire
 */

/**
* Fired when socket connected
* @param {('connecting'|'connected'|'rejected'|'disconnecting'|'disconnected')} state - general twilsock state
* @event Twilsock#stateChanged
*/

/**
 * Fired when connection is interrupted by unexpected reason
 * @type {Object}
 * @property {Boolean} terminal - twilsock will stop connection attempts
 * @property {String} message - root cause
 * @property {Number} [httpStatusCode] - http status code if available
 * @property {Number} [errorCode] - Twilio public error code if available
 * @event Twilsock#connectionError
 */